
import './copy.less'
import React from 'react'
console.log(React)
export default function BasicsImageCopy(props) {
  const src = props.ifon.ifon.imageIfon.path

  return (<div className='basicsImageCopy' style={{
    paddingTop: props.ifon.ifon.padding_top,
    paddingBottom: props.ifon.ifon.padding_bottom
  }}>
    { src && <img src={src} className='img' /> }
  </div>)
}
